/* eslint-disable no-unused-vars */
/*eslint no-console: "error"*/

import Vue from 'vue'
import Router from 'vue-router'

import AmplifyStore from '../store/store';
import { AmplifyEventBus } from 'aws-amplify-vue';
import '../amplify/amplify';
import { DOCUMENT_GROUP_TYPES } from "@/shared/enums/DocumentGroup";
import { CLIENT_ACTIONS } from "@/shared/enums/Client";
import { EMPLOYEE_ACTIONS } from "@/shared/enums/Employee";

const HomeView = () => import('@/components/appsView/homePage/HomeView');
const HomeHeader = () => import('@/components/appsView/homePage/HomeHeader');
const HomeFooter = () => import('@/components/appsView/homePage/HomeFooter');
const Welcome = () => import('@/components/home/Welcome');
const PageNotFound = () => import('@/components/common/PageNotFound');

const OrganizationProfiler = () => import('@/components/orgRegistration/OrganizationProfiler');
const Login = () => import('@/components/common/Authentication');
const UserWorkSpaceView = () => import('@/components/appsView/UserWorkSpaceView');
const UserWorkSpace = () => import('@/components/userApps/WorkSpace');
const OrgWorkSpaceView = () => import('@/components/appsView/OrgWorkSpaceView');
const OrgWorkSpaceMainDashBoard = () => import('@/components/orgApps/WorkSpaceMainDashBoard');

//views
const DashView = () => import("../components/orgApps/View/DashView");
const ClientDetailsView = () => import("../components/orgApps/View/ClientDetailsView");
const EmployeeDetailsView = () => import("../components/orgApps/View/EmployeeDetailsView");

//Dash-header
const EmployeeHeader = () => import("../components/orgApps/Employee/EmployeeHeader");
const ClientHeader = () => import("../components/orgApps/Client/ClientHeader");
const GroupTypeHeader = () => import("../components/orgApps/GroupType/GroupTypeHeader");
const DocumentGroupHeader = () => import("../components/orgApps/DocumentGroup/DocumentGroupHeader");
const DocumentRuleHeader = () => import("../components/orgApps/DocumentRule/DocumentRuleHeader");
const ReportHeader = () => import("../components/orgApps/Report/ReportHeader");
const AuthorizationRuleHeader = () => import("@/components/orgApps/Client/AuthorizationRule/AuthorizationRuleHeader");
const EmployeeVerticalHeader = () => import("@/components/orgApps/Employee/EmployeeVerticalHeader");
const ClientVerticalHeader = () => import("@/components/orgApps/Client/ClientVerticalHeader");
const ApprovalHeader = () => import("@/components/orgApps/Approval/ApprovalHeader");

//dashboards
const EmployeeDash = () => import('@/components/orgApps/dashboards/EmployeeDash');
const ClientDash = () => import('@/components/orgApps/dashboards/ClientDash');
const DocumentGroupDash = () => import('@/components/orgApps/dashboards/DocumentGroupDash');
const DocumentRuleDash = () => import('@/components/orgApps/dashboards/DocumentRuleDash');
const EmployeeTypeDash = () => import('@/components/orgApps/dashboards/EmployeeTypeDash');
const ClientTypeDash = () => import('@/components/orgApps/dashboards/ClientTypeDash');
const ReportDash = () => import('@/components/orgApps/dashboards/ReportDash');
const CalendarDash = () => import('@/components/common/calendar/Calendar');
const ApprovalDash = () => import('@/components/orgApps/dashboards/ApprovalDash');

//components
const DocumentRuleForm = () => import('@/components/orgApps/DocumentRule/DocumentRuleForm');
const DocumentGroupForm = () => import('@/components/orgApps/DocumentGroup/DocumentGroupForm');
const GroupTypeForm = () => import('@/components/orgApps/GroupType/GroupTypeForm');
const EmployeeForm = () => import('@/components/orgApps/Employee/EmployeeForm');
const ClientForm = () => import('@/components/orgApps/Client/ClientForm');
const DocumentFilesForm = () => import('@/components/orgApps/DocumentFile/DocumentFilesForm');
const DocumentFileTable = () => import("@/components/orgApps/DocumentFile/DocumentFileTable");
const ReportForm = () => import("@/components/orgApps/Report/ReportForm");
const ReportTable = () => import("@/components/orgApps/Report/ReportTable");
const AuthorizationRuleForm = () => import('@/components/orgApps/Client/AuthorizationRule/AuthorizationRuleForm');
const AuthorizationRuleTable = () => import("@/components/orgApps/Client/AuthorizationRule/AuthorizationRuleTable");
const AuthorizationRuleAssignmentForm = () => import('@/components/orgApps/Client/AuthorizationRule/AuthorizationRuleAssignmentForm');
const AssignmentView = () => import('@/components/orgApps/assignments/AssignmentView');
const ReportEmployeeUploadTable = () => import('@/components/orgApps/Report/ReportEmployeeUploadTable');
const ReportClientUploadTable = () => import('@/components/orgApps/Report/ReportClientUploadTable');
const EmployeeTable = () => import('@/components/orgApps/Employee/EmployeeTable');
const EmployeeClientTable = () => import('@/components/orgApps/Employee/EmployeeClientTable');
const ClientTable = () => import('@/components/orgApps/Client/ClientTable');
const ClientEmployeeTable = () => import('@/components/orgApps/Client/ClientEmployeeTable');
const ReportUploadForm = () => import('@/components/orgApps/Report/ReportUploadForm');

Vue.use(Router);
let user;

getUser().then((user) => {
  if (!user || !user.attributes) {
    AmplifyStore.commit('setUser', null);
  }
});

// TODO: Do we need this?
AmplifyEventBus.$on('authState', async (state) => {
  switch (state) {
    case 'signedOut':

      break;
    case 'signedIn':

      break;
    default:
      console.error('invalid state : ', state);
      break;
  }
});

function getUser() {
  return Vue.prototype.$Amplify.Auth.currentAuthenticatedUser().then((data) => {
    if (data && data.signInUserSession) {
      AmplifyStore.commit('setUser', data);
      return data;
    }
  }).catch(() => {
    AmplifyStore.commit('setUser', null);
    return null
  });
}

const router = new Router({
  routes: [
    {
      path: '/home',
      components: {
        default: HomeView,
        'header-router': HomeHeader,
        'footer-router': HomeFooter,
      },
      children: [
        { path: '', component: Welcome, meta: { requiresAuth: false } }
      ],
      meta: { requiresAuth: false }
    },
    {
      path: '/login',
      components: {
        default: Login,
        'header-router': HomeHeader,
        'footer-router': HomeFooter
      },
      name: 'login',
      meta: { requiresAuth: false }
    },
    {
      path: '/orgWorkSpace',
      alias: '/',
      components: {
        default: OrgWorkSpaceView
      },
      children: [
        {
          path: '',
          component: OrgWorkSpaceMainDashBoard,
          name: 'orgWorkSpace',
          meta: { requiresAuth: true }
        },
        {
          path: 'employee',
          component: DashView,
          children: [
            {
              path: '',
              components: {
                default: EmployeeDash,
                header: EmployeeHeader
              },
              props: { header: { hType: 'view' } },
              name: 'employeeTable',
              meta: { requiresAuth: true }
            },
            {
              path: 'add',
              components: {
                default: EmployeeForm,
                header: EmployeeHeader
              },
              props: { header: { hType: 'form' } },
              name: EMPLOYEE_ACTIONS.ADD.route,
              meta: { requiresAuth: true }
            },
            {
              path: 'edit/:id',
              components: {
                default: EmployeeForm,
                header: EmployeeHeader
              },
              props: { default: true, header: { hType: 'form' } },
              name: EMPLOYEE_ACTIONS.EDIT.route,
              meta: { requiresAuth: true }
            },
            {
              path: 'add-document-files',
              components: {
                default: DocumentFilesForm,
                header: EmployeeHeader
              },
              props: {
                default: { type: 'Employee' },
                header: { hType: 'documentFile' }
              },
              name: EMPLOYEE_ACTIONS.ADD_DOCUMENTS.route,
              meta: { requiresAuth: true }
            },
            {
              path: 'edit-document-files/:id',
              components: {
                default: DocumentFilesForm,
                header: EmployeeHeader
              },
              props: {
                default: (route) => ({ id: route.params.id, type: 'Employee' }),
                header: { hType: 'documentFile' }
              },
              name: EMPLOYEE_ACTIONS.EDIT_DOCUMENTS.route,
              meta: { requiresAuth: true }
            },
            {
              path: 'type',
              components: {
                default: EmployeeTypeDash,
                header: EmployeeHeader
              },
              props: { header: { hType: 'addType' } },
              name: 'employeeTypeTable',
              meta: { requiresAuth: true }
            },
            {
              path: 'details/:id/',
              components: {
                default: EmployeeDetailsView,
                header: EmployeeHeader,
                verticalHeader: EmployeeVerticalHeader
              },
              props: {
                header: (router) => ({
                  id: router.params.id,
                  hType: 'details'
                }
                ),
                verticalHeader: (router) => ({
                  id: router.params.id,
                  hType: 'details'
                }
                ),
              },
              children: [
                {
                  path: '',
                  redirect: {
                    name: 'employeeDetailsDocuments'
                  },
                  name: 'employeeDetails',
                  meta: { requiresAuth: true }
                },
                {
                  path: 'documents', component: DocumentFileTable,
                  //getting :id from parent
                  props: router => ({
                    id: router.params.id,
                    type: 'Employee'
                  }),
                  name: 'employeeDetailsDocuments',
                  meta: { isDetail: true, requiresAuth: true }
                },
                {
                  path: 'clients/list', component: EmployeeClientTable,
                  //getting :id from parent
                  props: router => ({
                    id: router.params.id,
                    type: 'Employee'
                  }),
                  name: 'employeeDetailsClientsTable',
                  meta: { isDetail: true, requiresAuth: true }
                },
                {
                  path: 'clients/assigment', component: AssignmentView,
                  //getting :id from parent
                  props: router => ({
                    id: router.params.id,
                    type: 'Employee',
                    assignmentFor: 'Clients'
                  }),
                  name: 'employeeDetailsClientsAssigment',
                  meta: { isDetail: true, requiresAuth: true }
                },
                {
                  path: 'reports', component: ReportEmployeeUploadTable,
                  isDetail: true,
                  //getting :id from parent
                  props: router => ({
                    id: router.params.id,
                    type: 'Employee'
                  }),
                  name: 'employeeDetailsReports',
                  meta: { isDetail: true, requiresAuth: true }
                },
                {
                  path: 'reports/add/:entity_id', component: ReportUploadForm,
                  isDetail: true,
                  //getting :id from parent
                  props: router => ({
                    id: router.params.id,
                    type: 'Employee',
                    entity_id: router.params.entity_id,
                  }),
                  name: 'employeeDetailsReportsAdd',
                  meta: { isDetail: true, requiresAuth: true }
                },
              ]
            },

          ]
        },
        {
          path: 'client', component: DashView,
          children: [
            {
              path: '',
              components: {
                default: ClientDash,
                header: ClientHeader
              },
              props: { header: { hType: 'view' } },
              name: 'clientTable',
              meta: { requiresAuth: true }
            },
            {
              path: 'add',
              components: {
                default: ClientForm,
                header: ClientHeader
              },
              props: { header: { hType: 'form' } },
              name: CLIENT_ACTIONS.ADD.route,
              meta: { requiresAuth: true }
            },
            {
              path: 'edit/:id',
              components: {
                default: ClientForm,
                header: ClientHeader
              },
              props: { default: true, header: { hType: 'form' } },
              name: CLIENT_ACTIONS.EDIT.route,
              meta: { requiresAuth: true }
            },
            {
              path: 'add-document-files',
              components: {
                default: DocumentFilesForm,
                header: ClientHeader
              },
              props: { default: { type: 'Client' }, header: { hType: 'documentFile' } },
              name: CLIENT_ACTIONS.ADD_DOCUMENTS.route,
              meta: { requiresAuth: true }
            },
            {
              path: 'edit-document-files/:id',
              components: {
                default: DocumentFilesForm,
                header: ClientHeader
              },
              props: { default: (route) => ({ id: route.params.id, type: 'Client' }), header: { hType: 'documentFile' } },
              name: CLIENT_ACTIONS.EDIT_DOCUMENTS.route,
              meta: { requiresAuth: true }
            },
            {
              path: 'type',
              components: {
                default: ClientTypeDash,
                header: ClientHeader
              },
              props: { header: { hType: 'addType' } },
              name: 'clientTypeTable',
              meta: { requiresAuth: true }
            },
            {
              path: 'authorization', component: DashView,
              children: [
                {
                  path: '',
                  components: {
                    default: AuthorizationRuleTable,
                    header: AuthorizationRuleHeader
                  },
                  props: { header: { hType: 'view' } },
                  name: 'clientAuthorizationTable',
                  meta: { requiresAuth: true }
                },
                {
                  path: 'add',
                  components: {
                    default: AuthorizationRuleForm,
                    header: AuthorizationRuleHeader
                  },
                  props: { header: { hType: 'form' } },
                  name: 'clientAuthorizationAdd',
                  meta: { requiresAuth: true }
                },
                {
                  path: 'clone/:path_id',
                  components: {
                    default: AuthorizationRuleForm,
                    header: AuthorizationRuleHeader
                  },
                  props: { default: true, header: (route) => ({ hType: 'form', path_id: route.params.path_id }) },
                  name: 'clientAuthorizationClone',
                  meta: { requiresAuth: true }
                },
                {
                  path: 'assignment/:path_id',
                  components: {
                    default: AuthorizationRuleAssignmentForm,
                    header: AuthorizationRuleHeader
                  },
                  props: { default: true, header: (route) => ({ hType: 'form', path_id: route.params.path_id }) },
                  name: 'clientAuthorizationAssignment',
                  meta: { requiresAuth: true }
                },
              ]
            },
            {
              path: 'details/:id',
              components: {
                default: ClientDetailsView,
                header: ClientHeader,
                verticalHeader: ClientVerticalHeader
              },
              props: {
                header: (router) => ({
                  hId: router.params.id,
                  hType: 'details'
                }
                ),
                verticalHeader: (router) => ({
                  hId: router.params.id,
                  hType: 'details'
                }
                )
              },
              children: [
                {
                  path: '',
                  redirect: {
                    name: 'clientDetailsDocuments'
                  },
                  name: 'clientDetails',
                  meta: { requiresAuth: true }
                },
                {
                  path: 'documents', component: DocumentFileTable,
                  //getting :id from parent
                  props: router => ({
                    id: router.params.id,
                    type: 'Client'
                  }),
                  name: 'clientDetailsDocuments',
                  meta: { isDetail: true, requiresAuth: true }
                },
                {
                  path: 'employee/list', component: ClientEmployeeTable,
                  //getting :id from parent
                  props: router => ({
                    id: router.params.id,
                    type: 'Client'
                  }),
                  name: 'clientDetailsEmployeesTable',
                  meta: { isDetail: true, requiresAuth: true }
                },
                {
                  path: 'employee/assigment', component: AssignmentView,
                  //getting :id from parent
                  props: router => ({
                    id: router.params.id,
                    type: 'Client',
                    assignmentFor: 'Employees'
                  }),
                  name: 'clientDetailsEmployeesAssigment',
                  meta: { isDetail: true, requiresAuth: true }
                },
                {
                  path: 'reports', component: ReportClientUploadTable,
                  isDetail: true,
                  //getting :id from parent
                  props: router => ({
                    id: router.params.id,
                    type: 'Client'
                  }),
                  name: 'clientDetailsReports',
                  meta: { isDetail: true, requiresAuth: true }
                },
                {
                  path: 'reports/add/:entity_id', component: ReportUploadForm,
                  isDetail: true,
                  //getting :id from parent
                  props: router => ({
                    id: router.params.id,
                    type: 'Client',
                    entity_id: router.params.entity_id,
                  }),
                  name: 'clientDetailsReportsAdd',
                  meta: { isDetail: true, requiresAuth: true }
                },
              ]
            },
          ]
        },
        {
          path: 'document-group', component: DashView,
          children: [
            {
              path: '',
              components: {
                default: DocumentGroupDash,
                header: DocumentGroupHeader
              },
              props: { header: { hType: 'view', docType: DOCUMENT_GROUP_TYPES.DOCUMENT }, default: { docType: DOCUMENT_GROUP_TYPES.DOCUMENT } },
              name: 'documentGroupTable',
              meta: { requiresAuth: true }
            },
            {
              path: 'add',
              components: {
                default: DocumentGroupForm,
                header: DocumentGroupHeader
              },
              props: { default: { docType: DOCUMENT_GROUP_TYPES.DOCUMENT }, header: (route) => ({ hType: 'form', tId: route.params.id }) },
              name: 'documentGroupAdd',
              meta: { requiresAuth: true }
            },
            {
              path: ':action/:id',
              components: {
                default: DocumentGroupForm,
                header: DocumentGroupHeader
              },
              props: {
                default: (route) => ({ id: route.params.id, action: route.params.action, docType: DOCUMENT_GROUP_TYPES.DOCUMENT }),
                header: (route) => ({ hType: 'form', tId: route.params.id, tAction: route.params.action, docType: DOCUMENT_GROUP_TYPES.DOCUMENT })
              },
              name: 'documentGroupAction',
              meta: { requiresAuth: true }
            },
          ]
        },
        {
          path: 'document-rule', 
          component: DashView,
          children: [
            {
              path: '',
              components: {
                default: DocumentRuleDash,
                header: DocumentRuleHeader
              },
              props: { header: { hType: 'view' } },
              name: 'documentRuleTable',
              meta: { requiresAuth: true }
            },
            {
              path: 'add/:path_type',
              components: {
                default: DocumentRuleForm,
                header: DocumentRuleHeader
              },
              props: { default: true, header: (route) => ({ hType: 'form', tId: route.params.id }) },
              name: 'documentRuleAdd',
              meta: { requiresAuth: true }
            },
            {
              path: 'clone/:id',
              components: {
                default: DocumentRuleForm,
                header: DocumentRuleHeader
              },
              props: { default: true, header: (route) => ({ hType: 'form', tId: route.params.id }) },
              name: 'documentRuleClone',
              meta: { requiresAuth: true }
            },
          ]
        },
        {
          path: 'group-type', 
          component: DashView,
          children: [
            {
              path: ':type/add',
              components: {
                default: GroupTypeForm,
                header: GroupTypeHeader
              },
              props: { default: true, header: (route) => ({ hType: 'form', tType: route.params.type, tId: route.params.id }) },
              name: 'groupTypeTable',
              meta: { requiresAuth: true }
            },
            {
              path: ':type/:action/:id',
              components: {
                default: GroupTypeForm,
                header: GroupTypeHeader
              },
              props: { default: true, header: (route) => ({ hType: 'form', tType: route.params.type, tId: route.params.id, tAction: route.params.action }) },
              name: 'groupTypeAction',
              meta: { requiresAuth: true }
            },
          ]
        },
        { 
          path: 'calendar',
          component: CalendarDash,
          name: 'calendar',
          meta: { requiresAuth: true }
        },
        {
          path: 'report',
          component: DashView,
          children: [
            {
              path: '',
              components: {
                default: ReportDash,
                header: ReportHeader
              },
              props: { header: { hType: 'view' } },
              name: 'reportTable',
              meta: { requiresAuth: true }
            },
            {
              path: 'add/',
              components: {
                default: ReportForm,
                header: ReportHeader
              },
              props: { default: true, header: (route) => ({ hType: 'form', tId: route.params.id }) },
              name: 'reportAdd',
              meta: { requiresAuth: true }
            },
            {
              path: 'clone/:id',
              components: {
                default: ReportForm,
                header: ReportHeader
              },
              props: { default: true, header: (route) => ({ hType: 'form', tId: route.params.id }) },
              name: 'reportClone',
              meta: { requiresAuth: true }
            },
          ]
        },
        {
          path: 'report-group',
          component: DashView,
          children: [
            {
              path: '',
              components: {
                default: DocumentGroupDash,
                header: DocumentGroupHeader
              },
              props: { header: { hType: 'view', docType: DOCUMENT_GROUP_TYPES.REPORT }, default: { docType: DOCUMENT_GROUP_TYPES.REPORT } },
              name: 'reportGroupTable',
              meta: { requiresAuth: true }
            },
            {
              path: 'add',
              components: {
                default: DocumentGroupForm,
                header: DocumentGroupHeader
              },
              props: { default: { docType: DOCUMENT_GROUP_TYPES.REPORT }, header: (route) => ({ hType: 'form', tId: route.params.id, docType: DOCUMENT_GROUP_TYPES.REPORT }) },
              name: 'reportGroupAdd',
              meta: { requiresAuth: true }
            },
            {
              path: ':action/:id',
              components: {
                default: DocumentGroupForm,
                header: DocumentGroupHeader
              },
              props: {
                default: (route) => ({ id: route.params.id, action: route.params.action, docType: DOCUMENT_GROUP_TYPES.REPORT }),
                header: (route) => ({ hType: 'form', tId: route.params.id, tAction: route.params.action, docType: DOCUMENT_GROUP_TYPES.REPORT })
              },
              name: 'reportGroupAction',
              meta: { requiresAuth: true }
            },
          ]
        },
        {
          path: 'approval',
          component: DashView,
          children: [
            {
              path: '',
              components: {
                default: ApprovalDash,
                header: ApprovalHeader
              },
              props: { header: { hType: 'view' } },
              name: 'approval',
              meta: { requiresAuth: true }
            }
          ]
        }
      ]
    },
    {
      path: '/userWorkSpace', components: {
        default: UserWorkSpaceView
      },
      children: [
        {
          path: '',
          component: UserWorkSpace,
          meta: { requiresAuth: true }
        }
      ]
    },
    {
      path: '/orgProfiler',
      component: OrganizationProfiler,
      meta: { requiresAuth: true }
    },
    {
      path: '*',
      components: {
        default: HomeView,
        'header-router': HomeHeader,
        'footer-router': HomeFooter,
      },
      children: [
        { path: '', component: PageNotFound, meta: { requiresAuth: false } }
      ],
      meta: { requiresAuth: false }
    }
  ],
  mode: 'history'
});

router.beforeEach(async (to, from, next) => {
  if (to.meta.requiresAuth) {
    user = await getUser();
    if (to.name !== 'login' && !user) {
      next({ name: 'login', query: { redirect: to.path } });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;